// Setup header
import Vue3ColorPicker from "vue3-colorpicker";
const profileMenuLink = document.getElementById('profile-menu-link');
const profileDropdown = document.getElementById('profile-dropdown');

if (profileMenuLink && profileDropdown) {
  profileMenuLink.addEventListener('click', () => {
    // e.preventDefault();
    profileDropdown.classList.toggle('show');
  });
}

// Vue Imports
import { createApp } from 'vue';

// Pinia
import { createPinia } from 'pinia';

// App
import App from "@/javascript/views/App.vue";

// Router
import router from '@/javascript/router/router';
import '@/entrypoints/application.scss';

// I18n
import { createI18n } from 'vue-i18n';
import { en as usaEnglish } from '@/javascript/i18n/usa_english';

const confirmForms = document.querySelectorAll("form.confirm");


// Wait for the DOM content to be fully loaded
document.addEventListener('DOMContentLoaded', () => {

  // Select all forms that have the 'data-monitor-changes' attribute
  const monitoredForms = document.querySelectorAll('form[data-monitor-changes]');

  // Initialize a flag to track if any form has been changed
  let formChanged = false;

  // Iterate over each monitored form
  monitoredForms.forEach((form) => {

    // Function to mark the form as changed when any input, textarea, or select element changes
    const markAsChanged = () => {
      formChanged = true;
    };

    // Add event listeners to all input, textarea, and select elements within the form
    form.querySelectorAll('input, textarea, select').forEach((e) => {
      e.addEventListener('change', markAsChanged); // Listen for changes
      e.addEventListener('input', markAsChanged);  // Listen for real-time input changes
    });
  });

  // Select all forms with the class 'back-btn-form'
  // document.querySelectorAll("form.back-btn-form").forEach((backBtn) => {
  //
  //   // Add event listener for form submission
  //   backBtn.addEventListener('submit', (e) => {
  //
  //     // Check if any form has been changed
  //     if (formChanged) {
  //
  //       // Retrieve the confirmation message from the form's data-confirm attribute
  //       const confirmMessage = backBtn.getAttribute('data-confirm');
  //
  //       // Display a confirmation dialog with the retrieved message
  //       const confirmWindow = window.confirm(confirmMessage);
  //
  //       // If the user cancels the confirmation, prevent the form submission
  //       if (!confirmWindow) {
  //         e.preventDefault();
  //       } else {
  //         // Reset the formChanged flag after successful submission
  //         formChanged = false;
  //       }
  //     }
  //   });
  // });

  // Add a global event listener for form submissions
  document.addEventListener('submit', (event) => {

    // Find the submit button within the submitted form with the class 'save-button'
    const submitButton = event.target.querySelector('.save-button');

    // Check if a submit button is found and if the form has been changed
    if (submitButton && formChanged) {

      // Retrieve the confirmation message from the submit button's data-confirm attribute
      const confirmMessage = submitButton.getAttribute('data-confirm') || 'Are you sure you want to save changes?';

      // Display a confirmation dialog with the retrieved message
      const confirmed = window.confirm(confirmMessage);

      // If the user cancels the confirmation, prevent the form submission
      if (!confirmed) {
        event.preventDefault();
      } else {
        // Reset the formChanged flag after successful submission
        formChanged = false;
      }
    }
  });

  // Handle browser back button or page unload
  window.addEventListener('popstate', (event) => {
    if (event.state && event.state.formChanged) {
      const confirmMessage = 'Are you sure you want to go back? Changes may be lost.';
      const confirmed = window.confirm(confirmMessage);
      if (!confirmed) {
        history.pushState({ formChanged: true }, ''); // Restore state
      } else {
        formChanged = false;
      }
    }
  });

  // Handle window beforeunload event
  window.addEventListener('beforeunload', (event) => {
    if (formChanged) {
      const confirmMessage = 'You have unsaved changes. Are you sure you want to leave this page?';
      event.returnValue = confirmMessage; // Standard for most browsers
      return confirmMessage; // For some older browsers
    }
  });
});


// Mount App
const mountApp = (locale) => {
  const app = createApp(App);
  app.config.devtools = true;
  const pinia = createPinia();
  const i18n = createI18n({
    legacy: false,
    locale: locale,
    fallbackLocale: 'en',
    messages: {
      en: usaEnglish,
    },
  });

  app
    .use(pinia)
    .use(i18n)
    .use(router)
    .use(Vue3ColorPicker);

  app.mount('#app');
};

if (document.getElementById('app')) {
  mountApp('en');
}
